module.exports = __webpack_public_path__ + "img/grurosso.284e22fc.png";